import styled from 'styled-components';
import {BLACK, GRAY3} from '../../../../globalVariables/GlobalVariables';
import {alignStart, dFlexBetween} from '../../../../globalVariables/GlobalFlex';

export const header = styled.div`
  ${dFlexBetween}
  ${alignStart}
  margin-bottom: 24px;
`;

export const logo = styled.img`
  margin-inline-end: 9px;
  width: 30px;
  height: 54px;
`;

export const headerText = styled.div``;

export const headerTitle = styled.p`
    font-size: 16px;
    font-weight: 700;
`;

export const subTitle = styled.p`
  font-size: 14px;
  color: ${GRAY3};
  margin-top: 2px;
  color: ${BLACK};
  font-weight: 700;
  text-align: start;
`;
